var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUsersIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    strokeWidth: 1,
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "multi-player-Icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "multi-player"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.896.708c-.977 0-1.771.795-1.771 1.771 0 .976.794 1.771 1.77 1.771.978 0 1.772-.795 1.772-1.77 0-.977-.794-1.772-1.771-1.772m0 4.25a2.482 2.482 0 01-2.48-2.479A2.482 2.482 0 013.897 0a2.482 2.482 0 012.479 2.48 2.482 2.482 0 01-2.48 2.478",
    id: "Fill-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.896 9.208H.7c-.392 0-.7-.36-.7-.822v-.61c0-1.344 1.06-2.636 1.106-2.69a.355.355 0 01.545.452C1.64 5.55.707 6.69.707 7.776v.61c0 .07.026.117.038.127l3.15-.013a.354.354 0 010 .708",
    id: "Fill-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.104.708c-.977 0-1.77.795-1.77 1.771 0 .976.793 1.771 1.77 1.771s1.771-.795 1.771-1.77c0-.977-.794-1.772-1.77-1.772m0 4.25a2.482 2.482 0 01-2.48-2.479A2.482 2.482 0 0113.105 0a2.482 2.482 0 012.478 2.48 2.482 2.482 0 01-2.479 2.478",
    id: "Fill-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3 9.208h-3.196a.354.354 0 010-.708h3.19c-.025-.002-.003-.047-.003-.114v-.61c0-1.091-.932-2.226-.942-2.238a.353.353 0 11.546-.451C15.939 5.14 17 6.432 17 7.777v.609c0 .461-.308.822-.7.822",
    id: "Fill-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5 5.667A2.836 2.836 0 005.667 8.5 2.836 2.836 0 008.5 11.333 2.836 2.836 0 0011.333 8.5 2.836 2.836 0 008.5 5.667m0 6.375A3.546 3.546 0 014.958 8.5 3.546 3.546 0 018.5 4.958 3.546 3.546 0 0112.042 8.5 3.546 3.546 0 018.5 12.042",
    id: "Fill-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.774 17H3.226c-.607 0-1.1-.453-1.1-1.01v-.853c0-1.876 2.251-3.654 2.347-3.73a.355.355 0 01.435.56c-.02.016-2.074 1.64-2.074 3.17v.854c0 .163.18.3.392.3h10.548c.213 0 .393-.137.393-.3v-.854c0-1.53-2.055-3.154-2.076-3.17a.354.354 0 01.436-.56c.096.076 2.348 1.854 2.348 3.73v.854c0 .556-.494 1.009-1.101 1.009",
    id: "Fill-11"
  }))))));
}

SvgUsersIcon.displayName = 'UsersIcon';
export default SvgUsersIcon;